import { fetchFromDuffelAPI } from "./fetchFromDuffelAPI";

export async function retrieveSeatMapsFromDuffelAPI(
  offer_id: string,
  client_key: string
) {
  const getSeatMapResponse = await fetchFromDuffelAPI(
    client_key,
    `offers/${offer_id}/seat_maps`
  );

  return getSeatMapResponse.data;
}
;
import "/Users/igor/Duffel/ancillaries-component/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";